import { SessionLengthStatsDto } from "../../dto/stats/session-length-stats.dto";
import { SessionLengthStats } from "../../models/stats/session-length-stats.model";
import { SessionDurationPreference } from "../../models/users/subrise-user.model";

export class SessionLengthStatsMapper {
  public static toModel(dto: SessionLengthStatsDto): SessionLengthStats {
    return {
      sessionTemplateId: dto.session_template_id,
      preferredSessionDuration: dto.preferred_session_duration as SessionDurationPreference,
      sessionCount: dto.session_count,
      estimatedDurationSeconds: dto.estimated_duration_seconds,
      averageActualDurationSeconds: dto.average_actual_duration_seconds,
      minActualDurationSeconds: dto.min_actual_duration_seconds,
      maxActualDurationSeconds: dto.max_actual_duration_seconds,
      medianActualDurationSeconds: dto.median_actual_duration_seconds,
      p95ActualDurationSeconds: dto.p95_actual_duration_seconds,
    };
  }
}
